import React, { useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Route, Switch, useLocation } from "react-router-dom";
import { Box } from "@material-ui/core";
import { useAuth } from "../../Providers/Auth/AuthProvider.jsx";
import { useBaseData } from "../../Providers/Data/BaseDataProvider.jsx";
import CompanyLayout from "./SharedComponents/CompanyLayout.jsx";
import MyScrollbars from "../../SharedComponents/MyScrollbars.jsx";
import useCompanyPublicId from "../../hooks/useCompanyPublicId.js";

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: 1300,
    width: "fit-content",
    marginLeft: "auto",
    marginRight: "auto",
    padding: 20,
  },
  flexVertical: {
    justifyContent: "space-between",
    minHeight: "calc(100vh - 310px)",
  },
}));

/** */
const PolicyPage = () => {
  const classes = useStyles();
  const { companyName } = useCompanyPublicId();
  const { company2 } = useAuth();
  const { company, setSchoolName } = useBaseData();

  const company_ = company || company2;

  const location = useLocation();
  const osRef = useRef(/** @type {?OverlayScrollbarsComponent} */ null);

  //
  useEffect(() => {
    if (companyName) {
      setSchoolName(companyName);
    }
  }, [companyName]);

  // автоскрол при переключении
  useEffect(() => {
    const osInstance = osRef.current && osRef.current.osInstance();
    if (osInstance) {
      osInstance.scroll(scrollTo, 50);
    }
  }, [location.pathname]);

  if (!company_) {
    return null;
  }

  return (
    <MyScrollbars ref={osRef}>
      <CompanyLayout>
        <Box className={classes.root}>
          <Switch>
            <Route path="/:companyName/terms">
              <div
                dangerouslySetInnerHTML={company_.policySettings.termsAndConditions?.sanitizedData() || { __html: "" }}
              />
            </Route>
            <Route exact path="/:companyName/policy">
              <div dangerouslySetInnerHTML={company_.policySettings.refund?.sanitizedData() || { __html: "" }} />
            </Route>
          </Switch>
        </Box>
      </CompanyLayout>
    </MyScrollbars>
  );
};

export default PolicyPage;
